import type { IconSize } from './Icon.types';

const SIZE_PX: Record<IconSize, number> = {
	'extra-small': 12,
	small: 16,
	medium: 24,
	large: 32,
};

export const getSize = (size: IconSize = 'medium') => {
	const px = SIZE_PX[size];
	return { width: px, height: px };
};

// Skeleton's native RN implementation only accepts a className, not a numeric size. Tailwind/NativeWind
// need the complete literal class name to appear in source to generate its CSS — a computed string like
// `size-${n}` is invisible to their static content scanning, so this can't be derived from SIZE_PX.
const SIZE_TO_SKELETON_CLASS: Record<IconSize, string> = {
	'extra-small': 'size-3',
	small: 'size-4',
	medium: 'size-6',
	large: 'size-8',
};

export const getSkeletonClassName = (size: IconSize = 'medium') => SIZE_TO_SKELETON_CLASS[size];
